import React from "react";
import PropTypes from "prop-types";

export default function ScoreBadge({ score }) {

  const getScoreStyle = () => {
    if (score > 64) {
      return {
        className: "badge-hot"
      };
    }

    if (score > 39) {
      return {
        className: "badge-warm"
      };
    }

    return {
      className: "badge-cold"
    };
  };

  return (
    <span
      className={`badge ${getScoreStyle().className}`}
    >
      {score}
    </span>
  );
}

ScoreBadge.propTypes = {
  score: PropTypes.number.isRequired,
};